module.exports = __webpack_public_path__ + "media/images/lb/213-45c5d221a9811b9cea05f89b79d70b65.svg";